// lib/pwa/queued-actions.ts
// The queued-actions seam of the service worker (lib/pwa/sw.ts, §66). Kept in its own file so sw.ts
// exports nothing: Serwist bundles sw.ts as ESM, and any export there would leave an `export {…}` in
// the built /sw.js, which a classic service worker can't parse (the worker would never start).

/** POST routes whose failed requests are queued and replayed. Add one only when it is idempotent. */
export const QUEUED_ACTION_ROUTES: readonly string[] = [];
